import '@babel/polyfill';
// Vue
import Vue from 'vue';
import App from './App.vue';
import router from './router/';
import store from './store/';
import ElementUI from 'element-ui';
import MonacoEditor from '@pillarjs/monaco-editor';
import PiCore from '@pillarjs/core';
import VueElementExtends from 'vue-element-extends';
import VHeight from './directives/height';

// Styles
import './styles/main.scss';

// Plugins
Vue.prototype.$bus = new Vue();
Vue.use(PiCore);
Vue.use(ElementUI, { size: 'small' });
Vue.use(MonacoEditor, { url: './vs' });
Vue.use(VueElementExtends);

// Directives
Vue.directive('height', VHeight);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
